import clsx from 'clsx';
import { FC, HTMLAttributes } from 'react';

import { ProgressBar } from '../progress-bar/ProgressBar';
import styles from './SplashLoader.module.scss';

const SCENARIO_LAST_LABEL_MULTIPLIER = 3;

interface SplashLoaderProps extends HTMLAttributes<HTMLDivElement> {
  labels: string[];
  duration?: number;
  isScenario?: boolean;
}

export const SplashLoader: FC<SplashLoaderProps> = ({
  labels,
  duration = 2_000,
  isScenario,
  className,
  ...rest
}) => {
  const items = labels.map((label, idx) => ({
    label,
    animationDuration: `${
      isScenario && idx === labels.length - 1
        ? duration * SCENARIO_LAST_LABEL_MULTIPLIER
        : duration
    }ms`,
    animationDelay: `${idx * duration}ms`,
  }));

  return (
    <div
      className={clsx(styles.container, className)}
      data-testid="splash-loader"
      {...rest}
    >
      {items.map((item, idx) => (
        <div className={styles.loaderItem} key={item.label}>
          <p className={styles.label}>{item.label}</p>
          <ProgressBar
            className={clsx(styles.styledProgressBar, {
              [styles.isLast]: idx === items.length - 1,
            })}
            animationDelay={item.animationDelay}
            animationDuration={item.animationDuration}
          />
        </div>
      ))}
    </div>
  );
};
